/**
 * Санитизация HTML через DOMPurify (плагин).
 * На сервере контент из доверенного JSON отдаётся как есть; на клиенте — санитизируется.
 */
export function useSanitizeHtml() {
  const app = useNuxtApp()
  const sanitize = (html: string | undefined | null): string =>
    (app as { $sanitizeHtml?: (h: string | undefined | null) => string }).$sanitizeHtml?.(html) ?? html ?? ''
  return { sanitize }
}
